import React, { useState } from 'react'
import {
  Button,
  Modal,
  Spin,
  Checkbox,
  message,
  Form,
  Input,
  Avatar,
  Row,
  Col
} from 'antd'
import IntlMessages from '../../util/IntlMessages'
import ds from '../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UserOutlined from '@ant-design/icons/lib/icons/UserOutlined'
import CloseOutlined from '@ant-design/icons/lib/icons/CloseOutlined'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import {
  filterUserByOutlet,
  getDecryptID
} from '../../appRedux/actions/GlobalMethods'
import { userSignIn, getMenu } from '../../appRedux/actions/Auth'
import {
  isEmptyObject,
  getCurrentPageID
} from '../../appRedux/actions/GlobalMethods'

const SwitchUserDialog = props => {
  const { open, setClose } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()
  const FormItem = Form.Item
  const [getLoading, setLoading] = React.useState(false)
  const [isEmailDisplay, setEmailDisplay] = React.useState(true)
  const [isShowPass, setIsShowPass] = React.useState(true)
  const [storedEmail, setStoredEmail] = React.useState('')
  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getSelectedRegister, setSelectedRegister] = React.useState('')
  const [availableUsers, setAvaialableUsers] = React.useState([])
  const [filteredUsers, setFilteredUsers] = React.useState([])
  const [searchQuery, setSearchQuery] = React.useState('')
  const [userName, setUserName] = React.useState('')

  const getStoreUsers = useSelector(({ Sell }) => Sell.getStoreUsers)
  //   const getStoreUsers = [
  //     {
  //       firstName: 'Ali',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Sultan',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Nasir',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Somro',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Viki',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Rik',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Dan',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Ravish',
  //       lastName: 'Bihari'
  //     },
  //     {
  //       firstName: 'Shukla',
  //       lastName: 'Bihari'
  //     }
  //   ]
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outletid = ''
      if (getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.id) {
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        outletid = getReduxSelectedStoreOutlets.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          let selOutlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
          setSelectedOutlet(selOutlet)
          outletid = selOutlet
        } else {
          setSelectedOutlet('')
        }
      }

      if (getReduxSelectedOutletReg && getReduxSelectedOutletReg.id) {
        setSelectedRegister(getReduxSelectedOutletReg.id)
        // reg = getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
        //   ? getReduxSelectedOutletReg.id
        //   : "";
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          let selReg = selectedReg.id ? selectedReg.id : ''
          setSelectedRegister(selReg)
        } else {
          setSelectedRegister('')
        }
      }

      if (getStoreUsers && getStoreUsers.length > 0 && outletid) {
        const userList = []
        getStoreUsers.map((user, key) => {
          const userOutlets = user.userOutlets
          if (userOutlets && userOutlets.length > 0) {
            if (
              filterUserByOutlet(
                user.userOutlets,
                getDecryptID(outletid),
                getReduxStoreInfo,
                getDecryptID(user.id)
              )
            ) {
              userList.push(user)
            }
          }
        })
        if (userList && userList.length > 0) {
          setAvaialableUsers(userList)
          setFilteredUsers(userList)
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxSelectedStoreOutlets, getStoreUsers, getReduxStoreInfo])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     if (getStoreUsers && getStoreUsers.length > 0) {
  //       const userList = []
  //       getStoreUsers.map((user, key) => {
  //         const userOutlets = user.userOutlets
  //         if (userOutlets && userOutlets.length > 0) {
  //           if (
  //             filterUserByOutlet(
  //               user.userOutlets,
  //               getDecryptID(getSelectedOutlet),
  //               getReduxStoreInfo,
  //               getDecryptID(user.id)
  //             )
  //           ) {
  //             userList.push(user)
  //           }
  //         }
  //       })
  //       if (userList && userList.length > 0) {
  //         setAvaialableUsers(userList)
  //         setFilteredUsers(userList)
  //       }
  //     }
  //   }

  //   return () => {
  //     mounted = false
  //   }
  // }, [getStoreUsers])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const filtered = availableUsers.filter(
        user =>
          user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.email.toLowerCase().includes(searchQuery.toLowerCase())
      )
      setFilteredUsers(filtered)
    }

    return () => {
      mounted = false
    }
  }, [searchQuery, availableUsers])

  // React.useEffect(() => {
  //     let mounted = true;
  //     if (mounted) {

  //     }
  //     return () => (mounted = false);
  // }, [getReduxCommonSetting]);

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }

  function emailSubmitted (email) {
    let userExist =
      filteredUsers && filteredUsers.length > 0
        ? filteredUsers.filter(qw => qw.email === email)
        : []
    if (userExist && userExist.length > 0) {
      userExist = userExist[0]
      if (
        userExist.userOutlets &&
        userExist.userOutlets.filter(
          er =>
            getDecryptID(er.outletID) === getDecryptID(getSelectedOutlet) ||
            getDecryptID(er.outletID) === '0'
        ).length
      ) {
        // 0 is for all outlets access
        setEmailDisplay(false)
        setStoredEmail(email)
      } else {
        message.info('User is not added for selected Outlet', 5)
      }
    } else {
      message.info('User does not exist.', 4)
    }
  }

  const onFinish = values => {
    if (isEmailDisplay) {
      const email = values.email ? values.email.trim().toLowerCase() : false
      const validate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        email ? email : ''
      )
      if (validate) {
        emailSubmitted(email)
        // let userExist =
        //   getStoreUsers && getStoreUsers.length > 0
        //     ? getStoreUsers.filter(qw => qw.email === email)
        //     : []
        // if (userExist && userExist.length > 0) {
        //   userExist = userExist[0]
        //   if (
        //     userExist.userOutlets &&
        //     userExist.userOutlets.filter(
        //       er =>
        //         getDecryptID(er.outletID) === getDecryptID(getSelectedOutlet) ||
        //         getDecryptID(er.outletID) === '0'
        //     ).length
        //   ) {
        //     // 0 is for all outlets access
        //     setEmailDisplay(false)
        //     setStoredEmail(email)
        //   } else {
        //     message.info('User is not added for selected Outlet', 5)
        //   }
        // } else {
        //   message.info('User does not exist.', 4)
        // }
      } else {
        message.warn('Provide correct Email')
      }
    } else {
      let pageID = getCurrentPageID()
      setLoading(true)
      const body = {
        storeName: localStorage.getItem('storeName'),
        // storeDataHash: localStorage.getItem('storeDataHash'),
        userName: storedEmail,
        userPassword: values.password,
        isOutRegDisabled: true,
        pageID: pageID
      }
      //It will redirect to sell screen ultimately
      // localStorage.setItem('switchRedirectURL', window.location.pathname)
      //It will reload the sale in progress
      // if (getCurrentSalesOrderData && !isEmptyObject(getCurrentSalesOrderData)) {
      //     localStorage.setItem("saleInProgress", JSON.stringify(getCurrentSalesOrderData));
      // }
      tryLogin(body)
    }
  }

  async function tryLogin (body) {
    const response = await dispatch(
      userSignIn(body, history, {
        OutletID: getSelectedOutlet,
        RegisterID: getSelectedRegister
      })
    )
    const result = await response
    if (result && result.data) {
      const respMenu = await dispatch(getMenu())
      const menuResult = await respMenu
      if (menuResult && menuResult.menus) {
        setLoading(false)
        onClosePopUp()
      } else {
        onClosePopUp()
        setLoading(false)
      }
    } else {
      setLoading(false)
      const msg = result.msgDescription
        ? result.msgDescription
        : 'Kindly verify credentials'
      message.error(msg, 4)
    }
  }

  function onClosePopUp () {
    setUserName('')
    form.resetFields()
    setStoredEmail('')
    setEmailDisplay(true)
    setClose()
  }

  function onUserClick (user) {
    if (user.email) {
      form.setFieldsValue({ email: user.firstName + '' + user.lastName })
      emailSubmitted(user.email)
      setUserName(user.firstName + '' + user.lastName)
    }
  }

  function onChangeSearch (e) {
    const aa = filteredUsers
    setSearchQuery(e.target.value)
  }
  return (
    <Modal
      className='switchuser-modal'
      title={
        <span>
          <IntlMessages id='topbar.switchuser' />{' '}
        </span>
      }
      visible={open}
      centered={true}
      onCancel={onClosePopUp}
      footer={
        <Form
          // initialValues={{ remember: true }}
          form={form}
          name={isEmailDisplay ? 'emailForm' : 'passwordForm'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className='input-grp'
        >
          <Button size='large' className='dk-btn-cancel' onClick={onClosePopUp}>
            <IntlMessages id='common.resource.cancel' />
          </Button>

          <Button
            size='large'
            className='dk-btn-add'
            type='primary'
            htmlType='submit'
            disabled={!getSelectedOutlet || filteredUsers.length == 0}
          >
            <IntlMessages id='switchbar.submit' />
          </Button>
        </Form>
      }
    >
      {getSelectedOutlet ? (
        <>
          {isEmailDisplay ? (
            <Spin
              tip={<IntlMessages id='sell.cashlisting.cashloading' />}
              spinning={getLoading}
              size='large'
            >
              {filteredUsers && filteredUsers.length > 0 ? (
                <>
                  <label>
                    Search User
                    {/* <IntlMessages id='switchbar.email' /> */}
                  </label>
                  <Form
                    // initialValues={{ remember: true }}
                    form={form}
                    name='emailForm'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    className='input-grp'
                  >
                    <FormItem
                      // rules={[{ required: true, message: 'Please input your E-mail!' }]}
                      name='email'
                    >
                      <Input
                        size='large'
                        prefix={
                          <UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />
                        }
                        placeholder='Search user name'
                        onChange={onChangeSearch}
                      />
                    </FormItem>
                  </Form>

                  {getSelectedOutlet && (
                    <div className='theme-scroll d-ul verticalline users-box scroll-height-3'>
                      <ul>
                        {filteredUsers.map((user, key) => {
                          const isEven = key % 2 === 0
                          return (
                            <li
                              className='SwitchUsers-wrap'
                              onClick={() => onUserClick(user)}
                            >
                              {user.profilePic ? (
                                <Avatar
                                  src={user.profilePic}
                                  className='gx-avatar gx-pointer'
                                  alt=''
                                />
                              ) : (
                                <Avatar
                                  style={{
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                  }}
                                  className={`gx-avatar gx-bg-${
                                    isEven ? 'green' : 'blue'
                                  }`}
                                  src={user.profilePic ? user.profilePic : ''}
                                  size={'large'}
                                >
                                  {!user.profilePic &&
                                    `${
                                      user.firstName
                                        ? user.firstName.charAt(0).toUpperCase()
                                        : ''
                                    }${
                                      user.lastName
                                        ? user.lastName.charAt(0).toUpperCase()
                                        : ''
                                    }`}
                                </Avatar>
                              )}

                              <p>
                                {user.firstName ? user.firstName : ''}
                                {!user.firstName && user.lastName
                                  ? user.lastName
                                  : ''}
                              </p>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <div>There are no other users</div>
              )}
            </Spin>
          ) : (
            <Spin
              tip={<IntlMessages id='sell.cashlisting.cashloading' />}
              spinning={getLoading}
              size='large'
            >
              <div>
                <h3 className='custom-gray-text'>
                  <IntlMessages id='switchbar.password' />
                  {` For ${userName}`}
                </h3>
              </div>
              <Form
                // initialValues={{ remember: true }}
                name='passwordForm'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className='gx-signin-form gx-form-row0'
              >
                <FormItem
                  rules={[
                    {
                      required: true,
                      message: 'Please input your Password!'
                    }
                  ]}
                  name='password'
                >
                  <Input
                    size='large'
                    // prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type='password'
                    placeholder='Password'
                  />
                </FormItem>
              </Form>
            </Spin>
          )}
        </>
      ) : (
        <>Kindly first select Outlet from Sell Menu then switch User</>
      )}
    </Modal>
  )
}

export default SwitchUserDialog
